import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomerBillingAdress from '../presenters/CustomerBillingAdress';
import CustomerShippingAdress from '../presenters/CustomerShippingAdress';
import {
  openCustomerShppingAddressSelector,
  closeCustomerShppingAddressSelector,
} from '../../../action/customer';
import '../SalesOrder.css';
import Total from '../presenters/Total';
import getFormValues from 'redux-form/lib/getFormValues';
import { setRate } from '../presenters/setRate';

const TotalContainer = ({
  subTotal,
  adjustment,
  shippingCharge,
  currency,
  salesOrderType,
}) => {
  // 안전한 숫자 변환 함수
  const safeNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  const total =
    safeNumber(subTotal) + safeNumber(shippingCharge) + safeNumber(adjustment);
  const finalTotal = salesOrderType === 8 ? -Math.abs(total) : total;

  return (
    <div className="CustomerDetail">
      <Total total={finalTotal} currency={currency.trim()} />
    </div>
  );
};

const toIntegerHelper = (num) => {
  let valueString = num.toString();
  let value = valueString.split('.')[1];
  return String(value).length;
};

const calculateDiscount = (discount) => {
  var T1 = Number('1e' + toIntegerHelper(discount));
  var T2 = Number('1e' + toIntegerHelper((100 * T1 - discount * T1) / T1));
  var returnDiscount =
    Math.floor(((100 * T1 - discount * T1) / T1) * T2) / (100 * T2);

  return returnDiscount;
};

export default connect((state) => ({
  subTotal: state.productOrderList.reduce((a, b) => {
    const company = state.company;
    const billingCountry = state.billingCountry;
    const currency = state.selectedCustomer.billingCustomer.Currency;
    const rate = setRate(
      {
        AACost: b.product.AACost,
        USDRetail: b.product.USDRetail,
        KRWRetail: b.product.KRWRetail,
      },
      currency,
      company,
      billingCountry
    );
    let amount = Number(
      (rate * Math.abs(b.quantity) * calculateDiscount(b.discount)).toFixed(
        currency && currency.trim() === 'KRW' ? 0 : 2
      )
    );
    return a + (state.salesOrderType === 8 ? -Math.abs(amount) : amount);
  }, 0),
  customerAddress: state.customerAddress,
  isCustomerShppingAddressSelectorOpen:
    state.isCustomerShppingAddressSelectorOpen,
  adjustment: !!getFormValues('SalesOrder')(state)
    ? getFormValues('SalesOrder')(state).Adjustment || 0
    : 0,
  shippingCharge: !!getFormValues('SalesOrder')(state)
    ? getFormValues('SalesOrder')(state).ShippingCharge || 0
    : 0,
  currency:
    state.selectedCustomer.billingCustomer.Currency != undefined
      ? state.selectedCustomer.billingCustomer.Currency
      : 'USD',
}))(TotalContainer);
